export const components = {
  '* Promotional areas with special values exclusive to some units may only be schedule at those units':
    '* Las áreas promocionales con valores especiales exclusivas de algunas unidades solo pueden ser agendadas en esas mismas unidades',
  Afternoon: 'Tarde',
  'Avoid sun exposition 15 days before the session for areas that are highly exposed to the sun and 5 days for less exposed areas':
    'Evitá la exposición al sol durante 15 días antes de la sesión para zonas muy expuestas y 5 días para zonas menos expuestas.',
  'Below some time suggestions for you':
    'Abajo algunas sugerencias de horarios para vos',
  'Choose another time': 'Elegí otro horario',
  City: 'Ciudad',
  Clinic: 'Clínica',
  'Do you want to speed up this process?': '¿Querés acelerar este proceso?',
  'Follow the recommendations below': 'Seguí las recomendaciones de abajo',
  'It was not possible to reschedule': 'No fue posible reprogramar',
  'Last clinic': 'Última clínica',
  Morning: 'Mañana',
  Night: 'Noche',
  Recommendations: 'Recomendaciones',
  'Remember to arrive on time to avoid lines and embarrassement':
    'Recordá llegar a tiempo para evitar filas y pasar un mal momento.',
  'Schedule at last clinic': 'Agendá en la última clínica',
  'Schedule on this time': 'Agendá en este horario',
  Select: 'Seleccionar',
  'Select a day to see the available times':
    'Seleccioná un día para ver los horarios disponibles',
  State: 'Estado',
  "Trim the hairs with a blade or cream 2 days before the session It's important that only the tip of the hair is exposed":
    'Recortá los vellos con cuchilla o crema depilatoria 2 días antes de la sesión. Es importante que solo la punta del vello esté expuesta.',
  Unavailable: 'No disponible',
  Understood: 'Entendido',
};
